import styled from 'styled-components';

import TableLayout, {
  EmbeddedTableNullState,
  TableTD,
  TableTH,
  TableTR,
} from 'dashboard/layouts/TableLayout';
import { ReportBusinessLookup } from 'dashboard/models/report/business-lookup';
import { IndustryClassification } from 'dashboard/models/report/business-lookup-result-edge';
import Card from 'design-system/components/Card';
import * as Spacing from 'design-system/variables/spacing';

const StickyTableTH = styled(TableTH)`
  position: sticky;
  top: 0;
`;

interface BusinessLookupIndustryClassificationsProps {
  report: ReportBusinessLookup;
}

const BusinessLookupIndustryClassifications = ({
  report,
}: BusinessLookupIndustryClassificationsProps) => {
  const result = report.attributes.result;
  const classifications = result?.['industry-classifications'] ?? [];

  const body = (
    <>
      <TableLayout
        containerMaxHeight={420}
        showHeader={true}
        isEmpty={classifications.length === 0}
        nullState={
          <EmbeddedTableNullState
            marginVertical={Spacing.BASE * 2}
            dataTestBlock='classifications-table'
          >
            No industry classifications found
          </EmbeddedTableNullState>
        }
        headerTR={
          <>
            <StickyTableTH>Classification title</StickyTableTH>
            <StickyTableTH>Type</StickyTableTH>
            <StickyTableTH>Code</StickyTableTH>
          </>
        }
      >
        {classifications.map((classification: IndustryClassification) => {
          return (
            <TableTR key={`classification-${classification.type}-${classification.code}`}>
              <TableTD>{classification.title}</TableTD>
              <TableTD>{classification.type?.toUpperCase()?.replace(/_/g, ' ')}</TableTD>
              <TableTD>{classification.code}</TableTD>
            </TableTR>
          );
        })}
      </TableLayout>
    </>
  );

  return (
    <>
      <Card.Title>Industry Classifications</Card.Title>
      {body}
    </>
  );
};

export default BusinessLookupIndustryClassifications;
